// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumEnvironmentState = {
  EnvStateUnknown: 'UNKNOWN',
  EnvStateCreating: 'CREATING',
  EnvStateUpdating: 'UPDATING',
  EnvStateRunning: 'RUNNING',
  EnvStateDeleting: 'DELETING',
  EnvStateDeleted: 'DELETED',
  EnvStateError: 'ERROR',
  EnvStateDegraded: 'DEGRADED',
  EnvStateScalingDown: 'SCALING_DOWN',
  EnvStateScaledDown: 'SCALED_DOWN',
  EnvStateScalingUp: 'SCALING_UP',
} as const;
export type EnumEnvironmentState =
  (typeof EnumEnvironmentState)[keyof typeof EnumEnvironmentState];

export function instanceOfEnumEnvironmentState(value: any): boolean {
  for (const key in EnumEnvironmentState) {
    if (Object.prototype.hasOwnProperty.call(EnumEnvironmentState, key)) {
      if (
        EnumEnvironmentState[key as keyof typeof EnumEnvironmentState] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function EnumEnvironmentStateFromJSON(json: any): EnumEnvironmentState {
  return EnumEnvironmentStateFromJSONTyped(json, false);
}

export function EnumEnvironmentStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentState {
  return json as EnumEnvironmentState;
}

export function EnumEnvironmentStateToJSON(
  value?: EnumEnvironmentState | null,
): any {
  return value as any;
}

export function EnumEnvironmentStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumEnvironmentState {
  return value as EnumEnvironmentState;
}
